import { Controller } from "@hotwired/stimulus";

// Manages the three-tile menu import selection on onboarding step 3.
// Clicking URL or PDF tile reveals the corresponding input.
// Timeout timer shows fallback after 150s during import.
export default class extends Controller {
  static targets = [
    "tiles",
    "urlForm",
    "pdfForm",
    "urlInput",
    "fileInput",
    "fileName",
    "dropzone",
    "error",
  ];
  static values = {
    timeout: { type: Number, default: 150000 },
    manualPath: String,
  };

  connect() {
    this._timeoutTimer = null;
  }

  disconnect() {
    clearTimeout(this._timeoutTimer);
  }

  selectUrl() {
    this.tilesTarget.classList.add("hidden");
    this.urlFormTarget.classList.remove("hidden");
    this.urlInputTarget.focus();
  }

  selectPdf() {
    this.tilesTarget.classList.add("hidden");
    this.pdfFormTarget.classList.remove("hidden");
  }

  goBack(event) {
    if (this._formVisible()) {
      event.preventDefault();
      this.urlFormTarget.classList.add("hidden");
      this.pdfFormTarget.classList.add("hidden");
      this.tilesTarget.classList.remove("hidden");
    }
  }

  submitUrl(event) {
    const url = this.urlInputTarget.value.trim();
    if (!url) {
      event.preventDefault();
      return;
    }
    this._startTimeout();
  }

  browsePdf() {
    this.fileInputTarget.click();
  }

  selectFile() {
    if (this.fileInputTarget.files.length) {
      const name = this.fileInputTarget.files[0].name;
      this.fileNameTarget.textContent = name;
      this.fileNameTarget.classList.remove("hidden");
      this.dropzoneTarget.classList.add("border-primary/50", "text-primary");
    }
  }

  submitPdf(event) {
    if (!this.fileInputTarget.files.length) {
      event.preventDefault();
      return;
    }

    const file = this.fileInputTarget.files[0];
    if (file.size > 10 * 1024 * 1024) {
      event.preventDefault();
      this._showError(this.fileInputTarget.dataset.sizeError);
      return;
    }

    this._startTimeout();
  }

  // Private

  _formVisible() {
    return (
      !this.urlFormTarget.classList.contains("hidden") ||
      !this.pdfFormTarget.classList.contains("hidden")
    );
  }

  _startTimeout() {
    this._timeoutTimer = setTimeout(() => {
      const statusEl = document.getElementById("menu-import-timeout");
      if (statusEl) {
        statusEl.classList.remove("hidden");
      }
    }, this.timeoutValue);
  }

  _showError(message) {
    this.errorTarget.textContent = message;
    this.errorTarget.classList.remove("hidden");
  }
}
